module.exports = __webpack_public_path__ + "static/img/Home1.e47d4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home1.png
// module id = HMoq
// module chunks = 1